<div class="print-gcp-root">
    <div class="print-gcp-header">
        <span>Documento</span>

        <button mat-icon-button type="button" class="print-gcp-close-button" (click)="dialogRef.close()" title="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="print-gcp-pdf-body">
        <ngx-extended-pdf-viewer *ngIf="data.pdf" [src]="data.pdf" enablePrintAutoRotate="true" [printResolution]="300"
            [showUnverifiedSignatures]="true" [showHandToolButton]="true" useBrowserLocale="true" height="100%"
            [zoom]="'page-width'">
        </ngx-extended-pdf-viewer>
    </div>
</div>
